import React, { Component } from 'react';
import { useImage } from 'react-image'
import {imagePath} from '../common'
export function HomeCollectionComponent(props) {
   
    const { src } = useImage({
        srcList: imagePath+props.item.image
    })
    return (
        <div class="newslideitem" onClick={()=>props._onClick(props.item.title
        )} style={{cursor:'pointer'}}>
            <img src={src} alt="" />
        </div>
    )
}